import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Valentina M.',
  city: 'Buenos Aires, Argentina',
  text: 'Llevaba 3 años con ataques de pánico en el subte. Después de leer el Volumen 2 tuve mi primera semana sin ninguno. No lo puedo creer todavía.',
  initial: 'V'
}, {
  name: 'Diego R.',
  city: 'Rosario, Argentina',
  text: 'Siempre pensé que era raro o que exageraba. El Volumen 1 me hizo entender que tenía una respuesta neurológica normal. Eso solo ya me cambió todo.',
  initial: 'D'
}, {
  name: 'Camila F.',
  city: 'Medellín, Colombia',
  text: 'Los guiones de calma del Bonus 2 los tengo en favoritos del celu. Los usé 4 veces y las 4 veces cortaron el pánico antes del pico.',
  initial: 'C'
}, {
  name: 'Marcela G.',
  city: 'Santiago, Chile',
  text: 'Le mandé el Bonus 6 a mi marido y por primera vez me acompañó bien durante un episodio. Eso no tiene precio.',
  initial: 'M'
}, {
  name: 'Matías L.',
  city: 'CABA, Argentina',
  text: "Esperaba otro 'respirá hondo'. Esto es completamente diferente. El Volumen 4 sobre biohacking me bajó la ansiedad de base en 2 semanas.",
  initial: 'M'
}, {
  name: 'Florencia T.',
  city: 'Córdoba, Argentina',
  text: 'El Mapa de Gatillos del Bonus 3 me mostró que mi ansiedad explotaba siempre los domingos a la noche. Nunca lo había relacionado.',
  initial: 'F'
}];
export function TestimonialsSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-14 px-4 bg-testimonials" ref={ref} data-id="element-189">
      <div className="max-w-6xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-center mb-10" data-id="element-191">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-192">
            Lo que dicen quienes ya lo tienen
          </h2>
          <p className="text-accent-teal text-lg sm:text-xl" data-id="element-193">
            Historias reales de personas como vos
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-194">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-card border-t-4 border-accent-gold rounded-xl p-6" data-id="element-195">
              <div className="flex items-center mb-4" data-id="element-196">
                <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-accent-gold font-bold text-xl mr-4" data-id="element-197">
                  {test.initial}
                </div>
                <div data-id="element-198">
                  <h4 className="text-white font-bold" data-id="element-199">{test.name}</h4>
                  <p className="text-text-secondary text-xs" data-id="element-200">{test.city}</p>
                </div>
              </div>
              <div className="flex mb-3" data-id="element-201">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-accent-gold fill-current" data-id="element-202" />)}
              </div>
              <p className="text-white/90 italic text-sm leading-relaxed" data-id="element-203">
                "{test.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}